var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1C3.89543 1 3 1.82081 3 2.83333V21.1667C3 22.1792 3.89543 23 5 23H19C20.1046 23 21 22.1792 21 21.1667V2.83333C21 1.82081 20.1046 1 19 1H5ZM5.5 14C5.22386 14 5 14.2239 5 14.5C5 14.7761 5.22386 15 5.5 15H18.5C18.7761 15 19 14.7761 19 14.5C19 14.2239 18.7761 14 18.5 14H5.5ZM5 16.5C5 16.2239 5.22386 16 5.5 16H18.5C18.7761 16 19 16.2239 19 16.5C19 16.7761 18.7761 17 18.5 17H5.5C5.22386 17 5 16.7761 5 16.5ZM5.5 18C5.22386 18 5 18.2239 5 18.5C5 18.7761 5.22386 19 5.5 19H14.5C14.7761 19 15 18.7761 15 18.5C15 18.2239 14.7761 18 14.5 18H5.5ZM5 20.5C5 20.2239 5.22386 20 5.5 20H8.5C8.77614 20 9 20.2239 9 20.5C9 20.7761 8.77614 21 8.5 21H5.5C5.22386 21 5 20.7761 5 20.5ZM14.5 3H17.5V12H14.5V3ZM13.5 5H10.5V12H13.5V5ZM9.5 7H6.5V12H9.5V7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.b737b66343a2db8d17bb031777018fba.svg";
export { ForwardRef as ReactComponent };